import React from "react";
import { getPnLBarColor } from "../../utils/statusUtils";

const AdvisorCardSlider = ({
  minValue,
  maxValue,
  startValue,
  endValue,
  currentPrice,
  status,
  transactionType = "BUY",
}) => {
  const min = Math.min(parseFloat(minValue), parseFloat(maxValue));
  const max = Math.max(parseFloat(minValue), parseFloat(maxValue));
  
  const start = Math.min(parseFloat(startValue), parseFloat(endValue));
  const end = Math.max(parseFloat(startValue), parseFloat(endValue));
  
  const totalRange = max - min || 1; 
  const safeRange = totalRange;

  const calculatePnLBar = () => {
    const entryMid = (start + end) / 2;
    const cmp = parseFloat(currentPrice);
    
    const pnlBarColor = getPnLBarColor(
      status,
      currentPrice,
      start,
      end,
      min,
      max,
      transactionType
    );

    let barStart = entryMid;
    let barEnd = entryMid;
    let barColor = "#d9d9d9";

    
    if (status === "CLOSED_STOPLOSSHIT") {
      if (transactionType === "BUY") {
        barStart = min;
        barEnd = entryMid;
      } else {
        barStart = entryMid;
        barEnd = max;
      }
      barColor = "#E53935"; 
    } 
    
    
    else if (status === "CLOSED_TARGETHIT") {
      if (transactionType === "BUY") {
        barStart = entryMid;
        barEnd = max;
      } else {
        barStart = min;
        barEnd = entryMid;
      }
      barColor = "#1E8C45";
    } 
    
    
    else if (status?.includes("LIVE")) {
      if (transactionType === "BUY") {
        if (cmp >= entryMid) {
          barStart = entryMid;
          barEnd = cmp;
          barColor = "#1E8C45"; 
        } else {
          barStart = cmp;
          barEnd = entryMid;
          barColor = "#E53935";
        }
      } else {
        
        if (cmp <= entryMid) {
          barStart = cmp;
          barEnd = entryMid;
          barColor = "#1E8C45"; 
        } else {
          barStart = entryMid;
          barEnd = cmp;
          barColor = "#E53935"; 
        }
      }
    } 
    
  
    else {
      barStart = start;
      barEnd = end;
     
      barColor = pnlBarColor || "#d9d9d9";
    }

    barStart = Math.max(min, Math.min(max, barStart));
    barEnd = Math.max(min, Math.min(max, barEnd));

    const leftPos = Math.max(0, Math.min(100, ((barStart - min) / safeRange) * 100));
    const rightPos = Math.max(0, Math.min(100, ((max - barEnd) / safeRange) * 100));

    return { leftPos, rightPos, barColor };
  };

  const pnlBar = calculatePnLBar();

  return (
    <div className="flex flex-col w-full items-stretch max-w-full transition-all duration-300">
      <div className="relative w-full h-1.5 sm:h-2 md:h-2.5 lg:h-3 bg-brand-border rounded-full my-1.5 lg:my-2 xl:my-2.5 overflow-hidden transition-all duration-300">
        <div
          className="absolute inset-y-0 transition-all duration-300"
          style={{
            left: `${pnlBar.leftPos}%`,
            right: `${pnlBar.rightPos}%`,
            backgroundColor: pnlBar.barColor,
          }}
        ></div>
      </div>

      <div className="flex justify-between items-center w-full mt-1 gap-1 sm:gap-1.5 lg:gap-2 xl:gap-2.5">
        <div className="flex flex-col font-roboto leading-tight flex-[0_0_auto] transition-all duration-300 text-left text-[0.65rem] sm:text-xs text-custom-darkGray">
          <div className="font-semibold truncate">{min}</div>
        </div>
        <div className="flex flex-col font-roboto leading-tight flex-1 transition-all duration-300 text-center text-[0.65rem] sm:text-xs text-custom-lightGray">
          <div className="font-semibold">P&L</div>
        </div>
        <div className="flex flex-col font-roboto leading-tight flex-[0_0_auto] transition-all duration-300 text-right text-[0.65rem] sm:text-xs text-custom-darkGray">
          <div className="font-semibold truncate">{max}</div>
        </div>
      </div>
    </div>
  );
};

export default AdvisorCardSlider;
